import React from "react";
import "../../../UI Design/About.css";
import Image from "../../../assets/Images/about.png";
import Resume from "../../../assets/PDF/Resume.pdf";

export default function About() {
  return (
    <div className="about" id="about">
      <div className="about-img">
        <img
          src={Image}
          alt="Network Error"
          onError={(e) => (e.target.style.display = "none")}
        />
      </div>
      <div className="about-content">
        <h2 className="heading">
          About <span>Me </span>
        </h2>
        <h3>Full Stack Developer!</h3>
        <p>
          A passionate Full Stack Developer with a knack for crafting elegant
          and efficient web applications. I specialize in both front-end and
          back-end development, creating seamless and user-friendly digital
          experiences. I have extensive knowledge of React Native and React JS.
        </p>
        <a href={Resume} className="btn" download={"Althaf_Hussain_Resume.pdf"}>
          Download CV
        </a>
      </div>
    </div>
  );
}
